import { FaGift, FaHome, FaAward, FaStore, FaBuilding } from "react-icons/fa";
import { GiGreekTemple } from "react-icons/gi";

const features = [
  {
    icon: <GiGreekTemple />,
    title: "Timeless Collections",
    description:
      "Elegant antique-inspired décor, German silver pieces and handcrafted treasures that never go out of style.",
  },
  {
    icon: <FaGift />,
    title: "Luxury Gifting",
    description:
      "Thoughtfully curated gifts for weddings, housewarmings, anniversaries and festive celebrations.",
  },
  {
    icon: <FaAward />,
    title: "Premium Quality",
    description:
      "Every product is selected with a focus on craftsmanship, durability and elegant finishing.",
  },
  {
    icon: <FaHome />,
    title: "Curated Home Décor",
    description:
      "Transform every corner of your home with stylish décor that reflects timeless elegance.",
  },
  {
    icon: <FaBuilding />,
    title: "Bulk Orders",
    description:
      "Corporate gifting, wedding return gifts and customized bulk orders for every occasion.",
  },
  {
    icon: <FaStore />,
    title: "Trusted Store",
    description:
      "A premium shopping experience with personalized service and carefully selected collections.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-[#f8f5ef] py-20 px-6 md:px-12 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}

        <div className="text-center mb-14">
          <span className="uppercase tracking-[0.35em] text-lg text-[#B88A3B]">
            Why Choose Us
          </span>

          <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mt-3">
            Experience the Legacy Difference
          </h2>

          <div className="w-24 h-1 bg-[#B88A3B] mx-auto mt-5 rounded-full"></div>

          <p className="max-w-3xl mx-auto mt-6 text-gray-600 text-lg leading-8">
            Discover timeless décor, premium craftsmanship and thoughtful
            gifting collections designed to add elegance to every space.
          </p>
        </div>

        {/* Cards */}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((item, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl border border-transparent hover:border-[#B88A3B] transition-all duration-300 hover:-translate-y-2"
            >
              {/* Icon */}

              <div className="w-16 h-16 rounded-full bg-[#FFF7E8] flex items-center justify-center text-[#B88A3B] text-3xl mb-6 group-hover:scale-110 transition-transform duration-300">
                {item.icon}
              </div>

              <h3 className="text-2xl font-serif text-gray-800 mb-4">
                {item.title}
              </h3>

              <p className="text-gray-600 leading-7">{item.description}</p>

              <div className="mt-6 w-12 h-[2px] bg-[#B88A3B] group-hover:w-24 transition-all duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
